import { create } from "zustand";
import { NotificationModel, PagedNotificationModel } from "./types";
type TabKey = "all" | "unread" | "archive";

export interface INotificationsState {
  initialNotificationState: PagedNotificationModel;
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setFilter: (filter?: "unread" | "archive") => void;
  setSearchText: (searchText?: string) => void;

  anchorEl: null | HTMLElement;
  setAnchorEl: (val: null | HTMLElement) => void;

  showNoFacilityModal: boolean;
  setShowNoFacilityModal: (val: boolean) => void;

  showDeleteDialog: boolean;
  setShowDeleteDialog: (open: boolean) => void;

  showMarkReadDialog: boolean;
  setshowMarkReadDialog: (showMarkReadDialog: boolean) => void;

  selectedNotifId: string;
  setSelectedNotifId: (selectedNotifId: string) => void;

  tab: TabKey;
  setTab: (tab: TabKey) => void;

  isAllMarkedRead: boolean;
  setIsAllMarkedRead: (val: boolean) => void;

  notifsToMark: NotificationModel[];
  setNotifsToMark: (val: NotificationModel[]) => void;
}

const useNotificationsStore = create<INotificationsState>((set) => ({
  initialNotificationState: {
    items: [],
    totalItem: 0,
    pageNumber: 1,
    pageSize: 10,
    searchText: undefined,
    filter: undefined,
  },
  setPageNumber: (pageNumber) =>
    set((state) => ({
      initialNotificationState: {
        ...state.initialNotificationState,
        pageNumber,
      },
    })),
  setPageSize: (pageSize) =>
    set((state) => ({
      initialNotificationState: {
        ...state.initialNotificationState,
        pageSize,
      },
    })),
  setFilter: (filter) =>
    set((state) => ({
      initialNotificationState: {
        ...state.initialNotificationState,
        filter,
      },
    })),
  setSearchText: (searchText) =>
    set((state) => ({
      initialNotificationState: {
        ...state.initialNotificationState,
        searchText,
      },
    })),

  anchorEl: null,
  setAnchorEl: (anchorEl) => set({ anchorEl }),

  showNoFacilityModal: false,
  setShowNoFacilityModal: (showNoFacilityModal) => set({ showNoFacilityModal }),

  showDeleteDialog: false,
  setShowDeleteDialog: (showDeleteDialog) => set({ showDeleteDialog }),

  showMarkReadDialog: false,
  setshowMarkReadDialog: (showMarkReadDialog) => set({ showMarkReadDialog }),
  selectedNotifId: "",
  setSelectedNotifId: (selectedNotifId) => set({ selectedNotifId }),

  tab: "all",
  setTab: (tab) => set({ tab }),

  isAllMarkedRead: false,
  setIsAllMarkedRead: (isAllMarkedRead) => set({ isAllMarkedRead }),

  notifsToMark: [],
  setNotifsToMark: (notifsToMark) => set({ notifsToMark }),
}));

export default useNotificationsStore;
